import { ReservedSavedAddressType } from "@mapmycustomers/shared/enum/SavedAddressType";

import GlobalSearchItemType from "@app/enum/GlobalSearchItemType";
import GlobalSearchItem, {
  AddressGlobalSearchItem,
} from "@app/types/globalSearch/GlobalSearchItem";

import GlobalSearchFilter from "../enum/GlobalSearchFilter";
import GlobalSearchSectionKey from "../enum/GlobalSearchSectionKey";

export interface GlobalSearchSection {
  items: GlobalSearchItem[];
  key: GlobalSearchSectionKey;
}

const LEAD_FINDER_ITEM: GlobalSearchItem = {
  entity: undefined,
  entityType: undefined,
  title: "",
  type: GlobalSearchItemType.LEAD_FINDER,
};

const buildGlobalSearchSections = ({
  addressItems,
  filter,
  isReadOnlyMember,
  loading,
  savedLocationItems,
  searchActivated,
  searchResults,
  setModeType,
  userRecents,
}: {
  addressItems: AddressGlobalSearchItem[];
  filter: GlobalSearchFilter;
  isReadOnlyMember: boolean;
  loading: boolean;
  savedLocationItems: GlobalSearchItem[];
  searchActivated: boolean;
  searchResults: GlobalSearchItem[];
  setModeType?: ReservedSavedAddressType;
  userRecents: GlobalSearchItem[];
}): GlobalSearchSection[] => {
  if (setModeType) {
    return [{ items: addressItems, key: GlobalSearchSectionKey.SET_MODE }];
  }
  const savedLocations = { items: savedLocationItems, key: GlobalSearchSectionKey.SAVED_LOCATIONS };
  if (filter === GlobalSearchFilter.SAVED_LOCATIONS) {
    return savedLocationItems.length ? [savedLocations] : [];
  }
  // The spinner hides the last search's rows while loading, so they mustn't be selectable
  const records = loading ? [] : searchResults;
  const recent = { items: loading ? [] : userRecents, key: GlobalSearchSectionKey.RECENT };
  if (filter !== GlobalSearchFilter.ALL) {
    return [searchActivated ? { items: records, key: GlobalSearchSectionKey.RECORDS } : recent];
  }
  const sections = searchActivated
    ? [
        {
          items: isReadOnlyMember || loading ? records : [LEAD_FINDER_ITEM, ...records],
          key: GlobalSearchSectionKey.RECORDS,
        },
        savedLocations,
      ]
    : [savedLocations, recent];
  // Empty Records and Recent stay to hold the spinner; Recent also keeps its heading when alone
  return sections.filter(
    ({ items, key }) =>
      items.length ||
      key === GlobalSearchSectionKey.RECORDS ||
      (key === GlobalSearchSectionKey.RECENT && (loading || !savedLocationItems.length))
  );
};

export default buildGlobalSearchSections;
